<script lang="ts" setup>
import { useChatStore } from '../stores/chatStore';

const chatStore = useChatStore();
const { t } = useI18n();

const message = computed(() => {
    if (chatStore.serviceStatus === 'maintenance') {
        return chatStore.serviceMessage || '';
    }
    return t('systemDown');
});

const iconName = computed(() =>
    chatStore.serviceStatus === 'maintenance'
        ? 'material-symbols:construction'
        : 'material-symbols:cloud-off'
);
</script>

<template>
    <div class="flex flex-col items-center justify-center h-full px-6 py-10 text-center gap-6">
        <Icon :name="iconName" size="56px" class="text-gray-400" />
        <p class="text-sm text-gray-600 leading-7 whitespace-pre-wrap">{{ message }}</p>
    </div>
</template>
